import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';

class SocialLinksFooter extends Component {
  render() {
    const { textTitle } = this.props;

    return (
      <div className="social">
        {textTitle && <h3 className="social__title"> {textTitle} </h3>}
        <div className="social__inner">
          <a
            href="https://www.facebook.com/InstaLinksOfficial"
            target="_blank"
            rel="noopener noreferrer"
            className="social__link">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a
            href="https://www.instagram.com/instalinks_official/"
            target="_blank"
            rel="noopener noreferrer"
            className="social__link">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          {/*<a
            href="https://twitter.com/Instalinks_com"
            target="_blank"
            rel="noopener noreferrer"
            className="social__link">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a
            href="https://www.youtube.com/channel/UC2qFBK5f2Id7w2Pov-D35tQ"
            target="_blank"
            rel="noopener noreferrer"
            className="social__link">
            <FontAwesomeIcon icon={faYoutube} />
          </a>*/}
        </div>
      </div>
    );
  }
}

export default SocialLinksFooter;



// WEBPACK FOOTER //
// ./src/components/SocialLinksFooter/SocialLinksFooter.js